import { withStyles } from '@material-ui/core';
import styles from './styles';

const LocationCard = ({
  classes,
  location,
  EditForm,
  DisplayCard,
  onEditLocation,
  onDeleteLocation,
  onClose,
  openForm,
  equipmentSizeList,
  isEditable,
  selectPolygonOnMap,
  isSelectedOnMap,
  isLocationNameAlreadyExist
}) => {
  const locationMappingId = location.locationMappingId;
  return (
    <>
      {isEditable && <div className={classes.locationLabel}>Edit Location</div>}
      <div id={locationMappingId}>
        {isEditable ? (
          <EditForm
            isSelectedOnMap={isSelectedOnMap}
            location={location}
            onLocationUpdate={onEditLocation}
            onCancelEdit={() => onClose({isDataSaved: false, locationMappingId})}
            equipmentSizeList={equipmentSizeList}
            selectPolygonOnMap={selectPolygonOnMap}
            isLocationNameAlreadyExist={isLocationNameAlreadyExist}
          />
        ) : (
          <DisplayCard
            isSelectedOnMap={isSelectedOnMap}
            location={location}
            openForm={openForm}
            selectPolygonOnMap={selectPolygonOnMap}
            onDelete={onDeleteLocation}
          />
        )}
      </div>
    </>
  );
};

export default withStyles(styles)(LocationCard);
